export const getParam = (name: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  const param = urlParams.get(name);

  return { param };
};
